'use client'

import { createIcon } from '@chakra-ui/icons'

export default createIcon({
  displayName: 'Plus',
  viewBox: '0 0 20 20',
  d: 'M14.9 3C16.0598 3 17 3.9402 17 5.1V14.9C17 16.0598 16.0598 17 14.9 17H5.1C3.9402 17 3 16.0598 3 14.9V5.1C3 3.9402 3.9402 3 5.1 3H14.9ZM14.9 4.4H5.1C4.7134 4.4 4.4 4.7134 4.4 5.1V14.9C4.4 15.2866 4.7134 15.6 5.1 15.6H14.9C15.2866 15.6 15.6 15.2866 15.6 14.9V5.1C15.6 4.7134 15.2866 4.4 14.9 4.4ZM10 6.5C10.3866 6.5 10.7 6.8134 10.7 7.2V9.299L12.8 9.3C13.1544 9.3 13.4473 9.56334 13.4936 9.90501L13.5 10C13.5 10.3866 13.1866 10.7 12.8 10.7H10.7V12.8C10.7 13.1544 10.4367 13.4473 10.095 13.4936L10 13.5C9.6134 13.5 9.3 13.1866 9.3 12.8L9.299 10.7H7.2C6.84562 10.7 6.55274 10.4367 6.50639 10.095L6.5 10C6.5 9.6134 6.8134 9.3 7.2 9.3L9.299 9.299L9.3 7.2C9.3 6.84562 9.56334 6.55274 9.90501 6.50639L10 6.5Z',
})
